import './ManageAuditioneesTab.css';

import { collection, deleteDoc, getDocs } from "firebase/firestore";
import { useEffect, useState } from "react"
import { db, getAllDataFrom } from "../../../../_shoru_shared_library/firebase/firebase_setup";
import { faCross } from "@fortawesome/free-solid-svg-icons";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import FormInput from '../../../../_shoru_shared_library/components/form/FormInput';


export default function ManageAuditioneesTab(props) {

  const [auditionees, setAuditionees] = useState(null);
  const [auditions, setAuditions] = useState(null);

  const [filteredAuditionees, setFilteredAuditionees] = useState(null);
  const [search, setSearch] = useState('');

  const [selected, setSelected] = useState(null);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const userData = props.userData;
  const allProjectData = props.projectData;
  const allCastingData = props.extraData;
  const seasons = props.organisationData.seasons.filter((x) => x.active).map((x) => x.uid);


  const handleDeleteAuditionees = async() => {
    setDeleting(true);
    try {
      const collectionRef = collection(db, userData.active_organisation_id, 'castingbot', 'auditionees');
      const snapshot = await getDocs(collectionRef);
      await Promise.all(
        snapshot.docs.map(doc => deleteDoc(doc.ref))
      );
      setAuditionees([]);
      setDeleteOpen(false);
    }
    catch(err) {
      console.error(err);
      alert('Could not delete auditionees. Please try again.')
    }
    finally {
      setDeleting(false);
    }
  }


  // Get auditionee data
  useEffect(() => {
    getAllDataFrom(userData.active_organisation_id, 'castingbot', 'auditionees', setAuditionees);
    // eslint-disable-next-line
  }, []);

  // Count auditions booked in active seasons
  useEffect(() => {
    if(!auditionees || auditions) return;
    if(!filteredAuditionees) setFilteredAuditionees(auditionees);
    const auditioneeUids = auditionees.map((x) => x.uid)
    let auditionsBooked = 0;
    allCastingData.forEach((show) => {
      const season = allProjectData.find(p => p.uid === show.uid).season;
      if(seasons.includes(season)) {
        show.slots?.forEach((slot) => {
          if(slot.auditionee_id && auditioneeUids.includes(slot.auditionee_id)) {
            auditionsBooked += 1;
          }
        })
      }
    });
    setAuditions(auditionsBooked);
  }, [auditionees]);

  // Apply search filters for auditionees
  useEffect(() => {
    const st = search.trim();
    if(auditionees === null) {
      setFilteredAuditionees(null);
      return;
    };

    let newFiltered = auditionees;
    if(!st.length) {
      newFiltered = auditionees.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    }
    else {
      newFiltered = auditionees.filter(x => 
        x.name.includes(st) 
        || x.email.includes(st) 
        || x.phone.replace(/\s+/g, '').replace(/^\+44*/, '').trim().includes(st)
      ).sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    }
    setFilteredAuditionees(newFiltered);
  }, [auditionees, search]);



  if(auditionees === null || auditions === null) return <SectionLoader />


  if(auditionees.length > 0) 
  {
    return (
      <>
        {
          selected && 
          <AuditioneeViewer auditionee={selected} castingData={allCastingData} projectData={allProjectData} seasons={seasons} setSelected={setSelected} />
        }
        {
          deleteOpen && 
          <DeleteViewer setDeleteOpen={setDeleteOpen} handleDelete={handleDeleteAuditionees} />
        }
        <SubTabParent passData={props}>
          <SubTabSection title='Delete Auditionees' description={`There are currently ${auditionees.length} auditionees in your organisation, with ${auditions} auditions booked across ${seasons.length} active season${seasons.length !== 1 ? 's': ''}`}>
            <button onClick={() => setDeleteOpen(true)} style={{backgroundColor: props.accentColour}}>Delete Auditionees</button>
          </SubTabSection>
          <SubTabSection title='View Auditionees' description='Click on an auditionee to see booked auditions' no_background>
            <FormInput value={search} setValue={setSearch} placeholder='search...' type='text' />
            <div className='auditionee-item-container'>
              {
                filteredAuditionees.map((a, i) => 
                  <div key={`${a.uid}-${i}`} onClick={() => setSelected(a)} className='auditionee-item'>
                    <p style={{color: '#777'}}>{i+1}</p>
                    <p>{a.name}</p>
                    <p style={{color: '#777'}}>{a.email}</p>
                    <p style={{color: '#777'}}>{a.phone}</p>
                  </div>
                )
              }
            </div>
          </SubTabSection>
        </SubTabParent>
      </>
    )
  }
  else 
  {
    return (
      <SubTabNoData 
        title='No Auditionees' 
        description="Nothing to see here"
      />
    )
  }
}



function AuditioneeViewer({auditionee:a, castingData, projectData, seasons, setSelected}) {

  const projectsAuditionedFor = castingData.map((c) => {
    let res = null;
    projectData.forEach((p) => {
      if(p.uid === c.uid) {
        if(seasons.includes(p.season)) {
          c.slots.forEach((s) => {
            if(s.auditionee_id === a.uid) {
              res = p;
            }
          })
        }
      }
    })
    return res;
  }).filter(Boolean);


  return (
    <div className='auditionee-overlay-container'>
      <div className='auditionee-overlay-background' onClick={() => setSelected(null)}>
        <div className='auditionee-overlay-menu' onClick={(e) => e.stopPropagation()}>
          <h2>{a.name}</h2>
          <p className='auditionee-overlay-contacts'>{a.email} | {a.phone}</p>
          {
            projectsAuditionedFor.length 
            ? <div className='auditionee-overlay-auditions-container'>
                {
                  projectsAuditionedFor.map((p, i) => (
                    <div className='auditionee-overlay-auditions-item' key={`${p.uid}-${i}`}>
                      <p>{p.name}</p>
                      <p>Week {p.week} {p.project_type}</p>
                    </div>
                  ))
                }
              </div>
            : <p className='auditionee-overlay-no-slots'>
                No Auditions Booked
              </p>
          }
        </div>
      </div>
    </div>
  )
}


function DeleteViewer({setDeleteOpen, deleting, handleDelete}) {

  const [deleteText, setDeleteText] = useState('');

  const deleteValid = (deleteText.trim().toLowerCase() === 'delete');

  return (
    <div className='auditionee-overlay-container'>
      <div className='auditionee-overlay-background' onClick={() => {if(!deleting) setDeleteOpen(false)}}>
        <div className='auditionee-overlay-menu' onClick={(e) => e.stopPropagation()}>
          <h2><b>DELETE AUDITIONEES</b></h2>
          <p style={{textAlign: 'center'}}>Type 'DELETE' below to confirm. Once deleted, auditionees <b style={{color: '#e74c3c'}}>cannot be recovered.</b></p>
          <input 
            placeholder='type here...'
            style={{
              width: '40%',
              minWidth: '200px',
              backgroundColor: '#151515',
              marginTop: '20px',
              marginBottom: '30px',
              textAlign: 'center'
            }} 
            value={deleteText} 
            onChange={(e) => setDeleteText(e.target.value)} 
          />
          <button disabled={!deleteValid || deleting} onClick={handleDelete} style={{fontWeight: '600', color: 'black', backgroundColor: deleteValid ? '#e74c3c' : '#555'}}>DELETE</button>
        </div>
      </div>
    </div>
  )
}